import { render, staticRenderFns } from "./c-notification-edit-form.vue?vue&type=template&id=00a633c0&scoped=true&"
import script from "./c-notification-edit-form.vue?vue&type=script&lang=js&"
export * from "./c-notification-edit-form.vue?vue&type=script&lang=js&"
import style0 from "./c-notification-edit-form.vue?vue&type=style&index=0&id=00a633c0&lang=scss&scoped=true&"
import style1 from "./c-notification-edit-form.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a633c0",
  null
  
)

export default component.exports